import React from "react";

// Classnames
import clsx from "clsx";

// Components
import Img from "components/Img";

// Lib
import { sanitize } from "dompurify";

// Interface
interface ICustomMessage {
  text?: string,
  title?: string,
  className?: string,
}

const CustomMessage: React.FC<ICustomMessage> = ({ text, title, className }) => {
  const cn = clsx(
    "custom-messages-info d-flex flex-ai-start",
    className ? className : ""
  );

  return (
    <div className={cn}>
      <Img isSvg name="hintSvg" className="custom-messages-info__icon" />
      <div className="custom-messages-info__block d-flex flex-direction-column flex-ai-start ml10">
        {title && <h2
          className="custom-messages-info__title"
          dangerouslySetInnerHTML={{ __html: sanitize(title || "") }}
        />}
        {text && <p
          className="custom-messages-info__text"
          dangerouslySetInnerHTML={{ __html: sanitize(text || "") }}
        />}
      </div>
    </div>
  );
};

export default CustomMessage;
